import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/memberVisitsSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const MemberVisitsView = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.memberVisits.moduleView);
  const selectedView = useSelector((state) => state.memberVisits.selectedFilters.moduleView);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedView}
      placeholder="Select View"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (data.id === selectedView.id) return;
        dispatch(actionCreators.updateModuleView(data));
      }}
    />
  );
};

export default MemberVisitsView;
